import { FC, PropsWithChildren } from 'react'

import { Close } from '@radix-ui/react-dialog'

import Clickable from 'core/components/lib/Clickable'
import Dialog, { DialogActions, DialogText } from 'core/components/lib/Dialog/Dialog'

export type AlertDialogProps = PropsWithChildren<{
  title: string
  content: string
  isOpen?: boolean
  onOpenChange?: (value: boolean) => void
}>

const AlertDialog: FC<AlertDialogProps> = ({ children, title, content, isOpen, onOpenChange }) => (
  <Dialog
    content={
      <>
        <DialogText>{content}</DialogText>
        <DialogActions>
          <Close asChild>
            <Clickable variant='secondary'>Okay</Clickable>
          </Close>
        </DialogActions>
      </>
    }
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    title={title}
  >
    {children}
  </Dialog>
)

export default AlertDialog
